import LegalLayout, {
  LegalSection,
  LegalList,
} from "@/components/common/LegalLayout";

/**
 * Public Terms of Service page for the Arsitektur Informasi PNBP (PNBP DMS),
 * an internal knowledge-management platform of Direktorat Jenderal Anggaran (DJA),
 * Kementerian Keuangan Republik Indonesia.
 */
export default function TermsOfServicePage() {
  return (
    <LegalLayout
      title="Syarat & Ketentuan Layanan"
      subtitle="Syarat & Ketentuan ini mengatur penggunaan Arsitektur Informasi PNBP oleh seluruh pengguna yang berwenang."
      lastUpdated="11 Juni 2026"
    >
      <LegalSection title="1. Penerimaan Ketentuan">
        <p>
          Dengan mengakses atau menggunakan Arsitektur Informasi PNBP
          (selanjutnya disebut "Platform"), Anda menyatakan telah membaca,
          memahami, dan menyetujui untuk terikat pada Syarat &amp; Ketentuan ini
          serta{" "}
          <a
            href="/privacy"
            className="font-medium text-blue-600 hover:underline"
          >
            Kebijakan Privasi
          </a>{" "}
          yang berlaku. Apabila Anda tidak menyetujuinya, mohon untuk tidak
          menggunakan Platform.
        </p>
      </LegalSection>

      <LegalSection title="2. Kelayakan dan Akses">
        <p>
          Platform merupakan sistem internal yang diperuntukkan bagi pegawai
          Direktorat Jenderal Anggaran (DJA), Kementerian Keuangan, serta
          pemangku kepentingan (stakeholder) PNBP yang telah diberi otorisasi.
          Akses diberikan berdasarkan peran (role) dan kebutuhan tugas. Anda
          tidak diperkenankan menggunakan Platform tanpa otorisasi yang sah.
        </p>
      </LegalSection>

      <LegalSection title="3. Akun dan Keamanan">
        <LegalList
          items={[
            "Anda bertanggung jawab menjaga kerahasiaan kredensial akun (nama pengguna dan kata sandi).",
            "Seluruh aktivitas yang dilakukan melalui akun Anda menjadi tanggung jawab Anda.",
            "Anda wajib segera melaporkan dugaan penyalahgunaan atau akses tidak sah atas akun Anda.",
            "Akun bersifat pribadi dan tidak boleh dialihkan atau digunakan bersama tanpa izin yang berwenang.",
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Penggunaan yang Diperbolehkan">
        <p>
          Platform digunakan untuk pengelolaan dokumen dan pengetahuan PNBP
          dalam rangka pelaksanaan tugas kedinasan. Anda setuju untuk
          menggunakan Platform secara wajar, sesuai peruntukannya, dan sesuai
          peraturan perundang-undangan yang berlaku.
        </p>
      </LegalSection>

      <LegalSection title="5. Perbuatan yang Dilarang">
        <p>Pengguna dilarang untuk:</p>
        <LegalList
          items={[
            "Mengakses, mengubah, atau menghapus data tanpa kewenangan yang sah.",
            "Mengunggah konten yang melanggar hukum, berbahaya, atau tidak relevan dengan pengelolaan PNBP.",
            "Membagikan dokumen atau informasi rahasia kepada pihak yang tidak berhak.",
            "Mengganggu, merusak, atau mencoba menembus keamanan sistem (termasuk rekayasa balik dan akses tidak sah).",
            "Menggunakan Platform untuk tujuan di luar kepentingan kedinasan.",
          ]}
        />
      </LegalSection>

      <LegalSection title="6. Kerahasiaan Dokumen PNBP">
        <p>
          Dokumen dan informasi pada Platform dapat bersifat rahasia atau
          terbatas. Anda wajib menjaga kerahasiaannya sesuai klasifikasi
          keamanan informasi yang berlaku dan tidak menyebarluaskannya tanpa
          kewenangan yang sah.
        </p>
      </LegalSection>

      <LegalSection title="7. Konten yang Dihasilkan AI">
        <p>
          Platform menyediakan fitur berbasis kecerdasan buatan (AI) untuk
          mengekstraksi metadata, menyusun ringkasan, serta menyarankan
          klasifikasi dan node taksonomi. Saran yang dihasilkan AI bersifat
          membantu dan dapat mengandung ketidakakuratan. Pengguna yang berwenang
          bertanggung jawab untuk meninjau dan memverifikasi hasil tersebut
          sebelum digunakan sebagai dasar pengambilan keputusan resmi.
        </p>
      </LegalSection>

      <LegalSection title="8. Hak Kekayaan Intelektual">
        <p>
          Seluruh dokumen, data, dan konten pada Platform merupakan milik atau
          berada dalam penguasaan Direktorat Jenderal Anggaran, Kementerian
          Keuangan Republik Indonesia, dan dilindungi oleh peraturan yang
          berlaku. Penggunaan konten hanya diperbolehkan untuk kepentingan
          kedinasan sesuai kewenangan Anda.
        </p>
      </LegalSection>

      <LegalSection title="9. Ketersediaan Layanan">
        <p>
          Kami berupaya menjaga Platform tetap tersedia dan andal, namun tidak
          menjamin layanan bebas gangguan. Platform dapat mengalami
          pemeliharaan, pembaruan, atau gangguan teknis sewaktu-waktu tanpa
          pemberitahuan terlebih dahulu.
        </p>
      </LegalSection>

      <LegalSection title="10. Pembatasan Tanggung Jawab">
        <p>
          Sepanjang diizinkan oleh peraturan yang berlaku, Platform disediakan
          "sebagaimana adanya". Pengelola tidak bertanggung jawab atas kerugian
          yang timbul akibat penggunaan yang tidak sesuai ketentuan, kelalaian
          pengguna dalam menjaga keamanan akun, atau penggunaan hasil AI tanpa
          verifikasi.
        </p>
      </LegalSection>

      <LegalSection title="11. Penangguhan dan Pengakhiran">
        <p>
          Kami berhak menangguhkan atau mengakhiri akses pengguna yang melanggar
          Syarat &amp; Ketentuan ini, peraturan yang berlaku, atau yang
          membahayakan keamanan dan integritas Platform, dengan tetap
          memperhatikan ketentuan kepegawaian dan tata kelola yang berlaku.
        </p>
      </LegalSection>

      <LegalSection title="12. Hukum yang Berlaku">
        <p>
          Syarat &amp; Ketentuan ini tunduk pada dan ditafsirkan berdasarkan
          hukum Republik Indonesia serta ketentuan internal Kementerian
          Keuangan.
        </p>
      </LegalSection>

      <LegalSection title="13. Perubahan Ketentuan">
        <p>
          Kami dapat memperbarui Syarat &amp; Ketentuan ini dari waktu ke waktu.
          Perubahan akan ditampilkan pada halaman ini dengan pembaruan tanggal
          "Terakhir diperbarui". Penggunaan Platform secara berkelanjutan
          setelah perubahan berarti Anda menyetujui ketentuan yang diperbarui.
        </p>
      </LegalSection>

      <LegalSection title="14. Hubungi Kami">
        <p>
          Untuk pertanyaan terkait Syarat &amp; Ketentuan ini, silakan hubungi
          kami melalui surel{" "}
          <a
            href="mailto:dja@kemenkeu.go.id"
            className="font-medium text-blue-600 hover:underline"
          >
            dja@kemenkeu.go.id
          </a>{" "}
          atau Direktorat Jenderal Anggaran, Kementerian Keuangan Republik
          Indonesia, Jakarta.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
